import { normalizeStationFromApi } from '@/lib/station-open-hours'
import { tattersallService } from '@/services/tattersall'
import { useMemo } from 'react'
import useSWR from 'swr'

export function useStations() {
	const { data, error, isLoading } = useSWR('stations', () =>
		tattersallService.getAllStations(),
	)

	const stations = useMemo(() => {
		if (!data) return []
		const normalized = data.map(normalizeStationFromApi)
		const seen = new Set<string>()
		return normalized.filter(station => {
			if (seen.has(station.id)) return false
			seen.add(station.id)
			return true
		})
	}, [data])

	return {
		stations,
		isLoading,
		isError: error,
	}
}
